<template>
  <div>
    <b-modal
      id="notification-pref-modal"
      size="lg"
      centered
      title="Notification Email Preferences"
      @close="closeModal"
    >
      <b-form>
        <b-form-group label="Toggle notification summary emails:">
          <b-form-radio-group
            name="notification-options"
            v-model="selectedNotificationOption"
            :options="notificationOptions"
            :disabled="notificationPrefs.isLoading"
          ></b-form-radio-group>
        </b-form-group>
        <b-form-group
          label="Frequency of emails:"
          :disabled="!selectedNotificationOption"
        >
          <b-form-radio-group
            name="frequency-options"
            v-model="selectedFrequencyOption"
            :options="frequencyOptions"
          ></b-form-radio-group>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="outline-danger" @click="closeModal">Cancel</b-button>
        <b-button :disabled="false" variant="primary" @click="savePreferences"
          >Save</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
const DAY = 'DAY';
const WEEK = 'WEEK';
const MONTH = 'MONTH';

export default {
  name: 'NotificationPrefModal',
  props: {
    projectToModify: Object,
    title: String,
  },
  emits: ['toggle', 'fetch'],
  data() {
    return {
      selectedNotificationOption: undefined,
      selectedFrequencyOption: undefined,
    };
  },
  computed: {
    ...mapGetters(['notificationPrefs']),
  },
  watch: {
    notificationPrefs() {
      this.selectedNotificationOption = this.notificationPrefs.enabled;
      this.selectedFrequencyOption = this.notificationPrefs.frequency;
    },
  },
  mounted() {
    this.fetchNotificationPreferences();
  },
  created() {
    this.notificationOptions = [
      { text: 'Enable', value: true },
      { text: 'Disable', value: false },
    ];
    this.frequencyOptions = [
      { text: 'Daily', value: DAY },
      { text: 'Weekly', value: WEEK },
      { text: 'Monthly', value: MONTH },
    ];
  },
  methods: {
    ...mapActions([
      'fetchNotificationPreferences',
      'updateNotificationPreferences',
    ]),
    closeModal() {
      this.$bvModal.hide('notification-pref-modal');
    },
    savePreferences() {
      this.updateNotificationPreferences({
        enabled: this.selectedNotificationOption,
        frequency: this.selectedFrequencyOption,
      });
      this.closeModal();
    },
  },
};
</script>

<style></style>
